import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

export const FlexRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
})) as typeof Box

export const FlexRowResponsive = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
})) as typeof Box

export const FlexRowResponsiveMedium = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
})) as typeof Box

export const FlexColumn = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
})) as typeof Box
